import { useCallback, ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState, BooleanFormState } from "@/lib/redux/types";
import { setBooleanFormValue } from "@/lib/redux/actions";

import { UICheckbox } from "@/lib/components/UICheckbox";

export function Checkbox({
  name,
  validate,
  markAsDirty,
}: {
  name: keyof BooleanFormState;
  validate?: (value: boolean) => boolean;
  markAsDirty?: () => void;
}): ReactElement {
  const value = useSelector((state: RootState) => state[name]);
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.checked;
      dispatch(
        setBooleanFormValue(name, newValue, validate?.(newValue) || false)
      );

      markAsDirty?.();
    },
    [dispatch, markAsDirty, name, validate]
  );

  return <UICheckbox isChecked={!!value} onChange={handleChange} />;
}
